@if (label) {
  <mat-label>{{label}}</mat-label>
}
<input
  matInput
  class='simpleInput'
  [disabled]="disabledFlag"
  (keyup.enter)="onFocusOut()"
  (focusout)="onFocusOut()"
  (keyup)="onKeyUp()"
  (keydown.enter)='$event.target.blur()'
  [(ngModel)]='data'
  (focusin)="startEdit()"
  (keydown.escape)="undo()"
  placeholder="{{placeholder}}"
>
